<template>
  <el-row
type="flex"
justify="space-between"
align="middle">
    <div>
      <h1 class="card-container__title">{{ title }}</h1>
      <p class="card-container__subtitle">Tổng số: {{ total }}</p>
    </div>
    <el-row
      class="card-container__actions"
      type="flex"
      justify="end"
      align="middle"
    >
      <el-button
        type="primary"
        size="small"
        icon="el-icon-refresh"
        :plain="plain"
        :disabled="disabled"
        @click="$emit('refresh')"
        >Làm mới</el-button
      >
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: "CardHeader",
  components: {},
  props: {
    title: String,
    total: Number,
    disabled: Boolean,
    plain: Boolean,
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
